import axios from 'axios';

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

const myApi = axios.create({

    baseURL: 'https://apiuniddet.ebtapps.com/api'
    //baseURL: 'http://localhost:3309/api'

});

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

myApi.interceptors.request.use((config) => {

    //const token = 'R9345FG35D68BE6R56ER51BSD36R51E6TJ8J';
    const token = sessionStorage.getItem('ebt_token_unidades_detenidas');

    if(token){

        config.headers['access-token'] = token;

    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

myApi.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if(error.response.status === 500){

        //logOut();
        console.log(error)

    }

    return Promise.reject(error);

});

export { myApi };